export default "__VITE_ASSET__DQOdmPrB__"